// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2FFWh","col":"styles_col__2rhYu"};